import {JshModule} from './jsh-module';

const getModuleScope = (identifier: string) => document.querySelector(`[jsh-module="${identifier}"]`) as HTMLElement;
const getConfig = (moduleScope: HTMLElement) => {
    const configAttributeValue = moduleScope?.getAttribute('jsh-config');
    return configAttributeValue ? JSON.parse(configAttributeValue) : {};
};
const getJshModule = (id: string) => {
    const moduleScope = getModuleScope(id);
    moduleScope?.removeAttribute('jsh-module');
    moduleScope?.setAttribute('jsh-module__loaded', id);
    const config = getConfig(moduleScope);

    const JshModule: JshModule = {
        moduleScope,
        config
    };

    return JshModule;
};

export default getJshModule;
